import React from 'react';
import { 
    Box, 
    Typography, 
    Paper,
    FormGroup,
    FormControlLabel,
    Checkbox,
    FormHelperText
} from '@mui/material';

/**
 * Company type options list for use across the application
 */
export const companyTypeOptions = [
    'Host', 
    'Venue', 
    'Catering', 
    'Sponsor', 
    'Other Service Provider'
];

/**
 * Company Type selection step for company onboarding
 */
export const CompanyTypeStep = ({ 
    companyTypes,
    setCompanyTypes,
    errors
}) => {
    // Handle checkbox change
    const handleTypeChange = (type) => {
        const currentIndex = companyTypes.indexOf(type);
        const newTypes = [...companyTypes];
        
        if (currentIndex === -1) {
            // Add the type
            newTypes.push(type);
        } else {
            // Remove the type
            newTypes.splice(currentIndex, 1);
        }
        
        setCompanyTypes(newTypes);
    };

    return (
        <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
            <Typography variant="h5" gutterBottom>
                Company Type
            </Typography>
            
            <Typography variant="body2" color="text.secondary" gutterBottom>
                Select all that apply to your business. This will help us tailor your experience.
            </Typography>
            
            <FormGroup sx={{ mt: 2 }}>
                {companyTypeOptions.map((type) => (
                    <FormControlLabel
                        key={type}
                        control={
                            <Checkbox
                                checked={companyTypes.includes(type)}
                                onChange={() => handleTypeChange(type)}
                            />
                        }
                        label={type}
                    />
                ))}
            </FormGroup>
            
            {errors?.companyTypes && (
                <FormHelperText error sx={{ mt: 1 }}>
                    {errors.companyTypes}
                </FormHelperText>
            )}
        </Paper>
    );
}; 